// xlsx is ~550 kB raw / 182 kB gzip and every exporter runs behind an export
// click, so it has no business in the initial bundle or in a page chunk. A
// module-scope `import 'xlsx'` anywhere reachable from a page pulls the whole
// sheets chunk in with it. The promise is memoised, so a session pays the
// download once. See docs/features/react-lazy-loading/phase-1-xlsx-seam.md.

// HOW TO USE THIS, so the seam stays one shape rather than six:
//
//   const XLSX = await loadXlsx();   <- the default. A local binding inside the
//                                       function that needs it.
//
// Reach for a module-scoped `let XLSX` + `ensureXlsx()` guard ONLY when
// non-exported helpers in the file reference `XLSX` and threading it through
// them as a parameter would be churn (importWizard/utils/excelParseCore.js,
// PublicCatalog/utils/catalogExports.js). That shape buys convenience at the
// cost of an invariant no tool checks: EVERY exported entry point must await
// the guard before any helper runs, and a miss fails only on a cold module -
// the first use in a session - so it can pass locally when another export
// warmed it first. If the file has no such helpers, use the local binding.
//
// Prefer loading AFTER the function's cheap guards (empty input, bad args), so
// a call that has nothing to write does not fetch 182 kB to discover that.
let xlsxModule;

export const loadXlsx = () => {
  xlsxModule =
    xlsxModule ||
    import('xlsx').then((mod) => {
      // `import * as XLSX` and `await import()` do not always agree on shape for
      // an interop-shimmed CJS dependency: one hands back the namespace, the
      // other can wrap it in `default`. Detect on a member every caller uses
      // rather than trusting either form.
      if (mod && typeof mod.utils !== 'undefined') return mod;
      return mod?.default ?? mod;
    });
  // Do not latch a failure. Memoising the promise means one offline blip would
  // otherwise break every export for the rest of the session with no refetch.
  return xlsxModule.catch((error) => {
    xlsxModule = undefined;
    throw error;
  });
};

export default loadXlsx;
